/* eslint-disable prettier/prettier */
import React from 'react';

import { ColorPalette } from 'theme/colors';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';

import Icon, { IconTypes } from './components/Icon';
import { Content, Title, TextSub, BgImage, TextButton, SubTitle } from './styles';

export enum BackgroundTypes {
  Cloud,
  Mountain,
  SimpleCloud,
}
export { IconTypes } from './components/Icon';

export interface Props {
  show: boolean;
  text: string;
  subText: any;
  buttonText?: string;
  buttonOnClick?: () => void;
  background?: BackgroundTypes;
  icon?: IconTypes;
  isError?: boolean;
  testId?: string;
  subTitle?: string;
}

const ResponseScreen = ({
  show,
  text,
  subText,
  buttonOnClick,
  background,
  icon,
  isError,
  buttonText,
  testId,
  subTitle,
}: Props) => {
  const { t } = useStoreTranslation();

  return (
    <ApplicationOverlayContent show={show} onClose={() => { }} backgroundColor={ColorPalette.HEX.AntiFlashWhite}>
      <Content>
        <Title>{text}</Title>
        {subTitle && <SubTitle>{subTitle}</SubTitle>}
        <TextSub>{subText}</TextSub>
        {icon !== undefined ? <Icon type={icon} /> : null}
        <BgImage type={background}>
          {!isError && (
            <TextButton
              onClick={buttonOnClick}
              value={buttonText || t('solicitationSuccess.btnSuccess')}
              testId={testId ? `${testId}-button` : undefined}
            />
          )}
        </BgImage>
      </Content>
    </ApplicationOverlayContent>
  );
};

export default ResponseScreen;
